"use client";

import { c as _c } from "react/compiler-runtime";
import { useDebounceValue } from "@opensea/ui-kit/hooks";
import { useSubscriptionStore } from "./subscription-store";
export const useSubscriptionStatus = () => {
  const $ = _c(4);
  const subscriptions = useSubscriptionStore(_temp);
  let t0;
  if ($[0] !== subscriptions) {
    t0 = function getStatus() {
      const subscriptionsList = Array.from(subscriptions.values());
      if (subscriptionsList.length === 0) {
        return;
      }
      if (subscriptionsList.every(_temp2)) {
        return {
          status: "paused"
        };
      }
      if (subscriptionsList.some(_temp3)) {
        return {
          status: "degraded",
          reason: "unknown"
        };
      }
      return {
        status: "live"
      };
    };
    $[0] = subscriptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getStatus = t0;
  let t1;
  if ($[2] !== getStatus) {
    t1 = getStatus();
    $[2] = getStatus;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const status = t1;
  const [debouncedStatus] = useDebounceValue(status, 1000);
  return status ?? debouncedStatus;
};
function _temp(state) {
  return state.subscriptions;
}
function _temp2(subscription) {
  return subscription.paused;
}
function _temp3(subscription_0) {
  return subscription_0.hasError;
}